import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hcpheader',
  templateUrl: './hcpheader.component.html',
  styleUrls: ['./hcpheader.component.scss']
})
export class HcpheaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
